// Personal portfolio data

export const consultantInfo = {
  name: "Akshay Sonalkar",
  title: "Software Engineer",
  tagline: "Engineer by Profession. Teacher by Passion.",
  description: "Software engineer with 10+ years of experience building scalable systems. Passionate about open source, exploring new corners of software engineering, and mentoring the next generation.",
  email: "sonalkarakshay.solapur@gmail.com",
  phone: "+91 9448428031",
  linkedin: "www.linkedin.com/in/akshay-sonalkar",
  location: "Pune, Maharashtra, India",
  image: "/akshay-photo.jpg"
};

export const experience = [
  {
    id: 2,
    company: "TransUnion",
    role: "Software Engineer 2",
    type: "Full-time",
    duration: "Jul 2022 – Jul 2023",
    location: "Bengaluru, Karnataka, India",
    highlights: [
      "Reviewed code, debugged problems, and corrected issues",
      "Managed development milestones from initial steps through final delivery",
      "Worked with back-end developers to design APIs",
      "Collaborated with designers to create sleek and innovative UI"
    ],
    skills: ["Spring Boot", "Google Cloud Platform", "React"]
  },
  {
    id: 3,
    company: "Mercedes-Benz Research & Development",
    role: "Senior Software Engineer",
    type: "Full-time",
    duration: "Sep 2020 – Jul 2022",
    location: "Bengaluru, Karnataka, India",
    highlights: [
      "Built and maintained backend services for enterprise-scale platforms",
      "Led development initiatives as a subject matter expert on Java systems",
      "Trained and mentored junior developers in Java frameworks and best practices",
      "Partnered with product and QA teams to resolve complex technical issues"
    ],
    skills: ["Java", "Spring Boot", "Microservices", "React.js"]
  },
  {
    id: 4,
    company: "Manhattan Associates",
    role: "Software Engineer",
    type: "Full-time",
    duration: "Jun 2019 – Sep 2020",
    location: "Bengaluru, Karnataka, India",
    highlights: [
      "Collaborated with project managers to select realistic coding milestones",
      "Contributed across the full systems development lifecycle",
      "Revised and modernized old codebases to reduce costs and improve functionality",
      "Coordinated with project management on database development timelines"
    ],
    skills: ["Java", "JSF"]
  },
  {
    id: 5,
    company: "Chemiasoft Private Limited",
    role: "Software Engineer",
    type: "Full-time",
    duration: "Jul 2016 – Jun 2019",
    location: "Bengaluru, Karnataka, India",
    highlights: [
      "Designed technology solutions meeting or exceeding performance expectations",
      "Built robust solutions meeting client requirements for scalability and performance"
    ],
    skills: ["Java", "Primefaces"]
  }
];

export const stats = [
  { label: "Years Experience", value: "10+" },
  { label: "Interviews Taken", value: "500+" },
  { label: "Companies", value: "4" },
  { label: "Passion", value: "Teaching" }
];
